/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/DailyChallenges/SpiderChallenge',[
        'lodash',
        'absolute/stringmanager',
        'absolute/textutils',
        'CardUI/IChallengeDefinition',
        'SolitaireShared/CardLogic/ChallengeConstants',
        'SolitaireShared/CardLogic/Card',
        'SolitaireShared/SpiderLogic/ChallengeAuthorities/AchieveScoreDailySpiderAuthority',
        'SolitaireShared/SpiderLogic/ChallengeAuthorities/BuildStacksDailySpiderAuthority',
        'SolitaireShared/SpiderLogic/ChallengeAuthorities/SolveGameDailySpiderAuthority'
    ],
    function (_, _s, TextUtils, IChallengeDefinition, ChallengeConstants, Card, AchieveScoreDailySpiderAuthority, BuildStacksDailySpiderAuthority, SolveGameDailySpiderAuthority) {
        "use strict";

        var SpiderChallenge = function (challengeType, parameters, config) {
            this.initSpiderChallenge(challengeType, parameters, config);
        };

        SpiderChallenge.constructor = SpiderChallenge;
        SpiderChallenge.prototype = Object.create(IChallengeDefinition.prototype);


        SpiderChallenge.GoalType =
        {
            /// <summary>
            /// No Parameters
            /// </summary>
            SolveGame: 0,

            /// <summary>
            /// PARAMETERS: ScoreRequired
            /// </summary>
            AchieveScore: 1,

            /// <summary>
            /// PARAMETERS: StacksRequired
            /// </summary>
            BuildStacks: 2
        };

        SpiderChallenge.prototype.GoalType = SpiderChallenge.GoalType;


        SpiderChallenge.prototype.initSpiderChallenge = function (challengeType, parameters, config) {
            IChallengeDefinition.call(this, challengeType, parameters, config);
        };

        SpiderChallenge.prototype.ConstructAuthority = function () {
            var authority = SpiderChallenge.AuthorityTypes[this.ChallengeType](this.Parameters);
            this.SetupOptionsForAuthority(authority);

            return authority;
        };

        SpiderChallenge.prototype.SetupOptionsForAuthority = function (authority) {
            authority.CardSupply.SetOption("SUITS", this.Parameters["SUITS"]);

            IChallengeDefinition.prototype.SetupOptionsForAuthority.call(this, authority);
        };


        SpiderChallenge.prototype.GetGoalDescription = function ()
        {
            try
            {
                switch (this.ChallengeType)
                {
                    case SpiderChallenge.GoalType.SolveGame:
                        return _s(this.CompleteGoalLocString("DailyChallengeGoal_SolveDeck"),
                            [
                                (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                                this.AllowedMoves.toString()
                            ]);

                    case SpiderChallenge.GoalType.AchieveScore:
                        return _s(this.CompleteGoalLocString("DailyChallengeGoal_AchieveScore"),
                            [
                                TextUtils.formatInt(this.Parameters[ChallengeConstants.KeyScoreRequired]),
                                (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                                this.AllowedMoves.toString()
                            ]);

                    case SpiderChallenge.GoalType.BuildStacks:
                        return _s(this.CompleteGoalLocString("DailyChallengeGoal_FinishStacks"),
                            [
                                this.Parameters[ChallengeConstants.KeyStacksRequired],
                                (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                                this.AllowedMoves.toString()
                            ]);

                    default:
                        return "";
                }
                }
            catch (e)
            {
                return "";
            }
        };

        SpiderChallenge.prototype.GetChallengeIconUrl = function ()
        {
            return "Content/Icons/DailyChallenges/spider.png"; // TODO texture path?
        };

        SpiderChallenge.prototype.GetModeName = function ()
        {
            //return SolitaireGamesMap.Titles[SolitaireGameMode.Spider];
            return "Spider"; // TODO check this
        };

        SpiderChallenge.prototype.GetShortGoalDescription = function ()
        {
            switch (this.ChallengeType)
            {
            case SpiderChallenge.GoalType.SolveGame:
                if(this.AllowedMoves > 0)
                    return _s("Moves_Solve_Challenge");

                if(this.AllowedTime > 0)
                    return _s("Timed_Solve_Challenge");

                return _s("Solve_Challenge");

            case SpiderChallenge.GoalType.BuildStacks:
                if(this.AllowedMoves > 0)
                    return _s("Moves_Stack_Challenge");

                if(this.AllowedTime > 0)
                    return _s("Timed_Stack_Challenge");

                return _s("Stack_Challenge");

            case SpiderChallenge.GoalType.AchieveScore:
                if(this.AllowedMoves > 0)
                    return _s("Moves_Score_Challenge");

                if(this.AllowedTime > 0)
                    return _s("Timed_Score_Challenge");

                return _s("Score_Challenge");

            default:
                return "";
            }
        };

        SpiderChallenge.MakeSolveAuthority = function (param) { return new SolveGameDailySpiderAuthority(param); }
        SpiderChallenge.MakeScoreAuthority = function (param) { return new AchieveScoreDailySpiderAuthority(param); }
        SpiderChallenge.MakeBuildStacksAuthority = function (param) { return new BuildStacksDailySpiderAuthority(param); }

        // note: the following relies on being indexed by GoalType values above
        SpiderChallenge.AuthorityTypes = [
            SpiderChallenge.MakeSolveAuthority,
            SpiderChallenge.MakeScoreAuthority,
            SpiderChallenge.MakeBuildStacksAuthority
        ];

        SpiderChallenge.FromDictionary = function (spec)
        {
            var retval = null;
            var challengeType = parseInt(spec.Data["CHDEF_ChallengeType"]);
            var parameters = {};

            //spec.Remove("CHDEF_ChallengeType");
            _.forEach(spec.Data, function (value, key)
            {
                if (key.indexOf("PARAM_") == 0)
                {
                    var nkey = key.substring(6);
                    parameters[nkey] = value; // TODO make sure this works
                }
            });

            retval = new SpiderChallenge(challengeType, parameters, spec);
            retval.FromDictionaryInternal(spec.Data);

            return retval;
        };

        SpiderChallenge.FirstParameters =
        {
            "SolveGame": null,
            "AchieveScore": "ScoreRequired",
            "BuildStacks": "StacksRequired"
        };

        SpiderChallenge.SecondParameters =
        {
            "SolveGame": null,
            "AchieveScore": null,
            "BuildStacks": null
        };

        return SpiderChallenge;

});

